// extracted by css-extract-rspack-plugin
export default {"labNameContainer":"labNameContainer-C6tW8v","labNameButton":"labNameButton-uM1Vii"};